module.exports = __webpack_public_path__ + "img/favicon-b.831c5d84.svg";